<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    style="z-index: 5000;"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4 black--text">
        
          <iframe
            :src="url"
            width="100%"
            height="600"
            frameborder="0" >
           </iframe>
      </v-card-text>
      <v-card-actions class="pt-3">
        <div>Don't forget to press the "complete" button before closing this dialog.</div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!options.noconfirm"
          color="grey"
          text
          class="body-2 font-weight-bold"
          @click.native="cancel"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "IframePopup",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      myIframe: null,
      url: null,
      title: null,
      options: {
        color: "blue ",
        width: 600,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },

  methods: {
    open(title, url, options) {
      this.dialog = true;
      this.title = title;
      this.url = url;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>